import { HEATING_SYSTEM_EXCHANGE_SYSTEM_LIST } from "./heating-system-exchange-system-list";
export const HEATING_SYSTEM_EXCHANGE_SYSTEM_KEY_LIST = HEATING_SYSTEM_EXCHANGE_SYSTEM_LIST.map((system) => system.key);
